import Typography from '@mui/material/Typography';
import React from 'react';
import { FieldError } from 'react-hook-form';

interface ErrorModel extends FieldError {
  value?: FieldError;
}

interface Props {
  error: FieldError | undefined;
}

export const TextError: React.FC<Props> = props => {
  const { error } = props;

  if (!error) {
    return null;
  }

  const localError = error as ErrorModel;

  return (
    <>
      <Typography color="error" component="div" sx={{ pt: 1 }} variant="f12Regular">
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*  @ts-ignore */}
        {localError.value?.message ?? localError.message}
      </Typography>
    </>
  );
};
